import * as React from 'react';
import { TooltipTrigger } from '@radix-ui/react-tooltip';
import { Button } from '@frontend/shadcn/components/ui/button';
import { Tooltip, TooltipContent } from '@frontend/shadcn/components/ui/tooltip';
import { CircleInfoIcon } from '@revfluence/fresh-icons/solid/esm';
import { Dialog, DialogContent, DialogFooter, DialogHeader } from '@frontend/shadcn/components/ui/dialog';

// Open modal to create offer
/* eslint-disable react/jsx-closing-tag-location */
interface IProps {
  isConfirmOfferCreationModalOpen: boolean;
  setIsConfirmOfferCreationModalOpen: (isModalOpen: boolean) => void;
  onFinish?: (isBoost?: boolean) => void;
  requiredFields: React.ReactNode;
  isSaving?: boolean
}
export const ConfirmOfferCreation = ({ isConfirmOfferCreationModalOpen, setIsConfirmOfferCreationModalOpen, onFinish, requiredFields, isSaving = false }: IProps) => {
  return <>
    <Dialog open={isConfirmOfferCreationModalOpen} onOpenChange={() => setIsConfirmOfferCreationModalOpen(false)}>
      <DialogContent className="w-[506px] rounded-2xl bg-grey-0 p-0">
        <div className="p-4 flex flex-col gap-4">
          <DialogHeader className="flex flex-row items-center justify-between p-0 space-y-0">
            <p className="text-primary text-base font-medium m-0 flex items-center"><CircleInfoIcon className="text-primary mr-2" fontSize={20} />Create your offer</p>
          </DialogHeader>
          <div className="flex flex-col bg-white">
            <p className="text-grey-5 text-sm font-normal m-0">  Click on save and continue to start creating your rewards for the very first time.
              You won't have to repeat this process. Once offer is created, you would be able to create rewards</p>
          </div>
        </div>
        <DialogFooter>
          <Button key="cancel" variant="secondary" onClick={() => setIsConfirmOfferCreationModalOpen(false)}>Cancel</Button>,
          <Tooltip key="create-offer">
            <TooltipTrigger asChild>
              <div className="inline-block">
                <Button variant="primary" type="submit" disabled={!!requiredFields || isSaving} onClick={() => onFinish()}>Create Offer & Continue</Button>
              </div>
            </TooltipTrigger>
            {requiredFields && (
              <TooltipContent>
                <span>{requiredFields}</span>
              </TooltipContent>
            )}
          </Tooltip>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  </>;
};
